import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type UpdateCustomSurfaceTreatmentPayload = ClientInferRequest<
  typeof contract.companySettings.updateCustomSurfaceTreatment
>["body"];

export type UpdateCustomSurfaceTreatmentResponse = ClientInferResponseBody<
  typeof contract.companySettings.updateCustomSurfaceTreatment,
  200
>;

export const updateCustomSurfaceTreatmentApi = async ({
  companyId,
  surfaceTreatmentId,
  payload,
}: {
  companyId: string;
  surfaceTreatmentId: string;
  payload: UpdateCustomSurfaceTreatmentPayload;
}): Promise<UpdateCustomSurfaceTreatmentResponse> => {
  const response = await api.companySettings.updateCustomSurfaceTreatment.mutation({
    params: { id: companyId, surfaceTreatmentId },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  if (response.status === 400) {
    throw new ApiError(response.body.message, response.status, response.body);
  }

  throw new ApiError("Failed to update custom surface treatment", response.status, response.body);
};
